var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMisisonPatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.12,0H10.88A10.89,10.89,0,0,0,0,10.88V83.12A10.89,10.89,0,0,0,10.88,94H83.12A10.89,10.89,0,0,0,94,83.12V10.88A10.89,10.89,0,0,0,83.12,0ZM90,83.12A6.89,6.89,0,0,1,83.12,90H10.88A6.89,6.89,0,0,1,4,83.12V10.88A6.89,6.89,0,0,1,10.88,4H83.12A6.89,6.89,0,0,1,90,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.16,37H57V24.84A3.88,3.88,0,0,0,53.14,21H40.86A3.88,3.88,0,0,0,37,24.84V37H24.84A3.88,3.88,0,0,0,21,40.86V53.14A3.88,3.88,0,0,0,24.84,57H37V69.16A3.88,3.88,0,0,0,40.86,73H53.14A3.88,3.88,0,0,0,57,69.16V57H69.16A3.88,3.88,0,0,0,73,53.14V40.86A3.88,3.88,0,0,0,69.16,37ZM69,53H56.88A3.88,3.88,0,0,0,53,56.88V69H41V56.88A3.88,3.88,0,0,0,37.12,53H25V41H37.12A3.88,3.88,0,0,0,41,37.12V25H53V37.12A3.88,3.88,0,0,0,56.88,41H69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisisonPatient);
export default __webpack_public_path__ + "static/media/misisonPatient.5badc874853c414a13a3c5b16f495574.svg";
export { ForwardRef as ReactComponent };